import { Metrics } from 'components/insights/constants';
import { formatPercentage, formatResponseTime } from 'components/insights/formatting';
import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';

import { StatTile, TilesGrid } from '../../shared/slideout/statTiles';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

// Entity-drill summary tiles: the landing determination rates + avg decision time, scoped to the
// clicked record, each rate showing its raw "N of M" count below (mirrors the landing highlights).
export default function InboundEntityDetailHeader({ loading, rollups }: Props) {
  const overall = rollups.overall.metrics;
  const acceptanceRate = overall.getCurrentDataPoint(Metrics.ACCEPTANCE_RATE, 0);
  const denialRate = overall.getCurrentDataPoint(Metrics.DENIAL_RATE, 0);
  const avgTimeToDecisionSeconds = overall.getCurrentDataPoint(Metrics.TIME_TO_FACILITY_DECISION_SECONDS_AVERAGE, 0);

  const acceptedCount = overall.getCurrentDataPoint(Metrics.ACCEPTED_COUNT, 0) ?? 0;
  const deniedCount = overall.getCurrentDataPoint(Metrics.DENIED_COUNT, 0) ?? 0;
  const pendingCount = overall.getCurrentDataPoint(Metrics.PENDING_COUNT, 0) ?? 0;

  // Row-grain total (determination buckets), not referral:count which de-dupes to a different grain.
  const totalReferrals = acceptedCount + deniedCount + pendingCount;

  return (
    <TilesGrid $columns={3}>
      <StatTile
        label='Acceptance Rate'
        tone='green'
        loading={loading}
        inlineAddendum
        primary={formatPercentage(acceptanceRate)}
        addendum={acceptanceRate != null ? `${acceptedCount} of ${totalReferrals} referrals received` : undefined}
      />
      <StatTile
        label='Denial Rate'
        tone='red'
        loading={loading}
        inlineAddendum
        primary={formatPercentage(denialRate)}
        addendum={denialRate != null ? `${deniedCount} of ${totalReferrals} referrals received` : undefined}
      />
      <StatTile
        label='Avg. Time to Facility Decision'
        loading={loading}
        primary={formatResponseTime(avgTimeToDecisionSeconds)}
      />
    </TilesGrid>
  );
}
